<template>
  <base-dialog width="500px" :visible.sync="visible" class="confirm-dialog">
    <template v-slot:header>提示</template>
    <div class="message">已成功{{ operation + size }}条数据，是否执行下一批？</div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确定</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import { operationMap } from "@/views/Front/Sheet/View/static"
import { isValidObjectId } from "@/utils/common"

export default {
  name: "confirm-dialog",
  components: { BaseDialog, BaseButton },
  props: {
    from: String,
    activeCustomBtn: Object,
    size: Number
  },
  data() {
    return {
      operationMap,
      visible: false
    }
  },
  computed: {
    operation() {
      return isValidObjectId(this.from) ? this.activeCustomBtn.name : this.operationMap[this.from]
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    submit() {
      this.$emit("nextBatch")
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog {
  .message {
    padding: 40px;
    font-size: 15px;
  }
  ::v-deep {
    .el-dialog__body {
      padding: 0 22px !important;
    }
  }
}
</style>
